import { VALUESERIES_ROUTE } from '../views/valueseries/valueseries';
import { VALUE_SERIES } from '../services/arsweb/RoutingPaths';

export class ValueSeriesStates {
    /** @ngInject */
    constructor($stateProvider) {
        this.$stateProvider = $stateProvider;
    }

    defineStates() {
        this.$stateProvider.state(VALUESERIES_ROUTE, {
            url: VALUE_SERIES,
            templateUrl: './app/views/valueseries/valueseries.html',
            controller: 'ValueSeriesController',
            controllerAs: 'vm',
            params: {
                pageTitle: 'BALANCES'
            },
        });
    }
}
